'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeTreemapIcon = function TraceTypeTreemapIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 60 60' }, props),
        _react2.default.createElement('path', { 'class': 'st0', fill: '#119DFF', d: 'M10.1 11.2h19.4v39.1H10.1z' }),
        _react2.default.createElement('path', { 'class': 'st1', fill: '#09FFFF', d: 'M30.6 11.2h19.6v21.5H30.6z' }),
        _react2.default.createElement('path', { 'class': 'st2', fill: '#43C0FF', d: 'M30.6 33.7h19.6v16.7H30.6z' })
    );
};

exports.default = TraceTypeTreemapIcon;